export default {
  value: 'סכום',
  type: 'סוג',
  date: 'תאריך',
  title: 'צפייה בתשלומים נוספים של הסוכן {1}',
  addFee: 'הוסף תשלום',
  modalTitle: 'צפייה בתשלום',
  archive: 'צפייה בארכיון',
  fileTile: 'תשלומים נוספים של הסוכן {1}',
};
